import { render } from "./detailsKnowledge.vue?vue&type=template&id=2fa0bbca"
import script from "./detailsKnowledge.vue?vue&type=script&lang=js"
export * from "./detailsKnowledge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__